var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenezuela(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask_ve",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_ve)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 3H25.5V9H-1.5V3Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 9H25.5V15H-1.5V9Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 15H25.5V21H-1.5V15Z",
    fill: "#CF142B"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 12.6,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.3,
    cy: 11.3,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.2,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 10.5,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.7,
    cy: 11.3,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.4,
    cy: 12.6,
    r: 0.45
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenezuela);
export default __webpack_public_path__ + "static/media/Venezuela.b18dbf64c7d1d450f712b6469b874da6.svg";
export { ForwardRef as ReactComponent };